module.exports = __webpack_public_path__ + "static/media/giovanni-intro-1.7db6441a.wav";